/**
 * Check if userAgent is mac.
 *
 * @return boolean;
 */
export function isMac(): boolean {
  const platform =
    typeof navigator === "undefined" ? "unknown" : navigator.userAgentData?.platform || navigator.platform || "unknown";
  return platform.toUpperCase().includes("MAC");
}
